import * as _ from "lodash";
import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";

const Autocomplete = ({ config }) => {
  const { t } = useTranslation();
  const options = _.get(config, "options", []);
  const value = _.get(config, "value", []);
  const onChange = _.get(config, "onChange", () => {});
  const onSearch = _.get(config, "onSearch", () => {});
  const style = _.get(config, "style", {});
  const menuStyle = _.get(config, "menuStyle", {});
  const map = _.get(config, "map", {
    id: "id",
    name: "name",
  });
  const placeholder = _.get(config, "placeholder", "");
  const isMulti = _.get(config, "isMulti", false);
  const isClearable = _.get(config, "isClearable", true);
  const isDisabled = _.get(config, "isDisabled", false);
  const defaultOptions = _.get(config, "defaultOptions", false);

  const [inputValue, setInputValue] = useState("");

  const parsedOptions = useMemo(
    () =>
      options.map((opt) => ({
        value: opt[map.id],
        label: opt[map.name],
        original: opt,
      })),
    [options, map]
  );

  const parsedValue = useMemo(() => {
    if (!value) return isMulti ? [] : null;
    if (isMulti && _.isArray(value)) {
      return parsedOptions.filter((opt) =>
        value.some((v) => v[map.id] === opt.value)
      );
    } else {
      return parsedOptions.find((opt) => opt.value === value[map.id]) || null;
    }
  }, [value, parsedOptions, map, isMulti]);

  useEffect(() => {
    const delay = setTimeout(() => {
      onSearch(inputValue);
    }, 300);
    return () => clearTimeout(delay);
  }, [inputValue, onSearch]);

  const handleChange = (selected) => {
    if (isMulti) {
      const data = selected?.map((s) => s.original) || [];
      onChange(data);
    } else {
      onChange(selected?.original || null);
    }
  };

  return (
    <Select
      options={parsedOptions}
      value={parsedValue}
      onChange={handleChange}
      onInputChange={setInputValue}
      placeholder={placeholder}
      noOptionsMessage={({ inputValue }) =>
        inputValue
          ? t("common.no_results_found")
          : t("common.no_data_available")
      }
      isMulti={isMulti}
      isClearable={isClearable}
      isDisabled={isDisabled}
      className="autocomplete"
      classNamePrefix="autocomplete"
      styles={{
        control: (base) => ({
          ...base,
          minHeight: 43,
          width: 200,
          borderRadius: 6,
          ...style,
        }),
        menu: (base) => ({
          ...base,
          width: 200,
          zIndex: 9999,
          ...menuStyle,
        }),
        menuList: (base) => ({
          ...base,
          maxHeight: 200,
          overflowY: "auto",
        }),
      }}
      defaultOptions={defaultOptions}
    />
  );
};

export default Autocomplete;
